import Type from "@/model/types/Type";

const type = {
    BEFORE: 1,
    DURING: 2,
    AFTER: 3,
}

const list = [
    {
        value: type.BEFORE,
        text: "Abertura",
    },
    {
        value: type.DURING,
        text: "Durante",
    },
    {
        value: type.AFTER,
        text: "Finalização",
    },
]

const contains = function (typeInput) {
    return Type.contains(list, typeInput)
}

export default {
    type,
    list,
    contains,
}